import "../../../static/js/loaders/jquery";
var buttons = $("button.atozblockbuttons");
$(buttons).on('click', function () {
	var scope = $(this).closest('.atozblock-container');
	var url = $(this).attr('href');

	if ($(this).closest('.atozblock-container').hasClass('show-single')) {
		if ($(this).hasClass('selected')) {
			$(this).removeClass("selected");
			$('.atozblock--accordion', scope).show();
		} else {
			$(buttons, scope).removeClass("selected");
			$(this).addClass("selected");

			$('.atozblock--accordion', scope).hide();
			$(url).show();
		}
	} else {
		$(buttons, scope).removeClass("selected");
		$(this).addClass("selected");

		$('html, body').animate({
			scrollTop: $(url).offset().top - 60
		}, 100,
			'linear');
	}
});
